import { Injectable } from '@angular/core';
import { JoyrideService } from 'ngx-joyride';
import { GuidedTourStep } from './guider.interfaces';
import { GUIDED_TOUR } from './GUIDED_TOUR';

@Injectable({
  providedIn: 'root',
})
export class GuiderService {
  constructor( private joyrideService: JoyrideService) {}

  public startGuidedTour() {
    this.joyrideService.startTour(
      {
        steps: [
          GuidedTourStep.AddParty,
          GuidedTourStep.AddEditParty,
          GuidedTourStep.Notify,
          GuidedTourStep.Sort,
          GuidedTourStep.Search,
          GuidedTourStep.Actions,
          GuidedTourStep.Reservations,
          GuidedTourStep.Recent,
          GuidedTourStep.Analytics,
          GuidedTourStep.Settings,
          GuidedTourStep.Final
        ],
        showCounter: false,
        themeColor: '#768a9e'
      }
    );
  }
  public getGuidTitle(name) {
    return GUIDED_TOUR[name]?.title;
  }

  public getGuidText(name) {
    return GUIDED_TOUR[name]?.text;
  }

}
